module.exports = __webpack_public_path__ + "static/projects-1-794a3f9fa88e8ffdb3a7f418e23e21d0.jpg";